export type Reference = {
  n: number;
  short: string;
  citation: string;
  /** Verified-source caveat to show beside the citation. */
  note?: string;
  /** Missing details that must be supplied before any use. */
  placeholder?: string;
};

export const REFERENCES: Reference[] = [
  {
    n: 1,
    short: "Kyowa Kirin · MINT final results, October 2026",
    citation:
      "Kyowa Kirin. Announcement of the final results of the German MINT real-world study of mogamulizumab in mycosis fungoides and Sézary syndrome. October 2026.",
    placeholder:
      "Insert exact title, release date, document/URL identifier and, once available, the peer-reviewed publication. All MINT figures shown are provisional and must be verified against the final study materials.",
  },
  {
    n: 2,
    short: "Kim YH et al. Lancet Oncol 2018 · MAVORIC",
    citation:
      "Kim YH, Bagot M, Pinter-Brown L, et al. Mogamulizumab versus vorinostat in previously treated cutaneous T-cell lymphoma (MAVORIC): an international, open-label, randomised, controlled phase 3 trial. Lancet Oncol. 2018;19(9):1192–1204.",
    note: "Compartment response values displayed in this prototype must be checked against the primary publication before use.",
  },
  {
    n: 3,
    short: "German expert recommendations · mogamulizumab in MF/SS",
    citation: "German expert recommendations on the use of mogamulizumab in mycosis fungoides and Sézary syndrome.",
    placeholder:
      "Insert authors, title, journal, year, volume and pages. Statements attributed to this source in the prototype are placeholders pending verbatim verification.",
  },
  {
    n: 4,
    short: "POTELIGEO® SmPC / Fachinformation",
    citation: "POTELIGEO® (mogamulizumab) 4 mg/mL concentrate for solution for infusion. Summary of Product Characteristics / Fachinformation.",
    placeholder:
      "Insert the current, locally applicable version and revision date for Germany, Austria and Switzerland (CH: Swissmedic-approved Fachinformation), and the marketing authorisation holder.",
  },
  {
    n: 5,
    short: "Olsen E et al. Blood 2007 · ISCL/EORTC staging",
    citation:
      "Olsen E, Vonderheid E, Pimpinelli N, et al. Revisions to the staging and classification of mycosis fungoides and Sézary syndrome: a proposal of the International Society for Cutaneous Lymphomas (ISCL) and the cutaneous lymphoma task force of the European Organization of Research and Treatment of Cancer (EORTC). Blood. 2007;110(6):1713–1722.",
    note: "Blood classification has since been refined by updated ISCL/USCLC/EORTC consensus. Confirm which definitions apply locally.",
    placeholder: "Insert citation of the updated consensus if it is to be used.",
  },
];
